(function () {
  // The "Free shipping" row's flag icon opens the shipping policy as
  // an in-page popover instead of navigating to a separate page —
  // the policy content itself is server-rendered into the hidden
  // modal already (shop.policies.shipping_policy.body), so this is
  // just show/hide, no fetch involved.
  function initProduct(productInfo) {
    var trigger = productInfo.querySelector('[data-shipping-policy-trigger]');
    var modal = productInfo.querySelector('[data-shipping-policy-modal]');
    if (!trigger || !modal) return;

    var closeEls = modal.querySelectorAll('[data-shipping-policy-modal-close]');

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }

    trigger.addEventListener('click', open);
    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  function init() {
    document.querySelectorAll('product-info').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
